import React from 'react';
import Footer from '../../Layout/Footer';

const AboutUs = () => {
  return (
    <>
      {/* Navigation */}
      <nav>
        <div className="nav-container">
          <h1 className="logo">Raivens Technologies</h1>
          <div className="nav-buttons">
            <a href="/login" className="button button-primary">Login</a>
            <a href="/login" className="button button-primary">Register</a>
          </div>
        </div>
      </nav>

      <div className="common-wrap">
        <div className="container">
          <h2 className="section-title mb-4"><strong>About Us</strong></h2>
          <div className="content">
            <p>
              <strong>Leading the Future of GPS Technology for the Banking Sector</strong>
            </p>
            <p>
              Welcome to Raivens Technologies Pvt. Ltd, a trusted name in GPS device manufacturing with over seven years of industry leadership. Headquartered in Tonk, Rajasthan, with a state-of-the-art manufacturing unit at G-845, RIICO Industrial Area, Sitapura, Jaipur, we specialize in designing and producing high-quality Aadhaar-based GPS devices tailored for the banking sector and beyond.
            </p>
            
            <h3>Our Expertise</h3>
            <p>
              We are pioneers in GPS tracking solutions, providing cutting-edge devices that comply with Reserve Bank of India (RBI) regulations, ensuring seamless tracking and security for banks, financial institutions, and cash logistics companies. Our devices are engineered for precision, durability, and advanced connectivity, making us the preferred choice for secure asset tracking.
            </p>
            
            <h3>Our Journey</h3>
            <p>
              For the past seven years, we have been at the forefront of innovation in GPS technology, consistently improving our products to meet the evolving needs of the financial sector. Our commitment to quality and performance has earned us partnerships with leading banks across India, reinforcing our reputation as an industry leader in GPS-based security solutions.
            </p>
            
            <h3>Our Manufacturing Excellence</h3>
            <p>
              Our two manufacturing facilities are equipped with the latest technology, enabling us to design, develop, and deliver top-tier GPS devices with unmatched efficiency. From sourcing high-quality components to rigorous quality control, we ensure that every device meets the highest industry standards.
            </p>
            
            <h3>E-commerce & Accessibility</h3>
            <p>
              To make our products more accessible, we also sell our GPS devices on Amazon, ensuring quick and hassle-free procurement for businesses and individuals alike.
            </p>
            
            <h3>Why Choose Us?</h3>
            <p>
              ✔ Industry Leader in Aadhaar-based GPS technology<br/>
              ✔ Trusted by Banks & Financial Institutions across India<br/>
              ✔ Compliant with RBI Regulations for secured GPS tracking<br/>
              ✔ High-Quality Manufacturing with state-of-the-art facilities<br/>
              ✔ E-commerce Availability through Amazon for easy ordering
            </p>
            
            <h3>Our Vision</h3>
            <p>
              We aim to revolutionize GPS technology by continuously innovating and delivering reliable, secure, and regulatory-compliant tracking solutions that empower businesses and institutions with real-time location intelligence.
            </p>
            
            <h3>Get in Touch</h3>
            <p>
              <strong>Manufacturing Unit:</strong> Raivens Technologies Pvt. Ltd., Sonwa Road, Near Power House, Tonk, Rajasthan, India<br/>
              <strong>Manufacturing Unit:</strong>Plot No 4, Laxmi Vilas, Choudhary Colony, Sawai Madhopur Road, Tonk, Rajasthan, India - 304001<br/>
              <strong>Email:</strong> info@raivens.com<br/>
              <strong>Phone:</strong> +91 8696606662, +91-7023863380
            </p>
            <p>
              Join us in redefining GPS security and compliance—empowering the banking sector with precision and trust.
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default AboutUs;
